const { createReducer } = require('../helpers')
const {
  GET_USER_APPOINTMENTS_LIST,
  GET_USER_APPOINTMENTS_LIST_SUCCESS,
  GET_USER_APPOINTMENTS_LIST_ERROR,
  GET_USER_APPOINTMENTS_LIST_RESET,
  GET_USER_APPOINTMENT_DETAILS,
  GET_USER_APPOINTMENT_DETAILS_SUCCESS,
  GET_USER_APPOINTMENT_DETAILS_ERROR,
  GET_USER_APPOINTMENT_DETAILS_RESET,
  GET_DOCTOR_APPOINTMENT_LIST,
  GET_DOCTOR_APPOINTMENT_LIST_SUCCESS,
  GET_DOCTOR_APPOINTMENT_LIST_ERROR,
  GET_DOCTOR_APPOINTMENT_LIST_RESET,
  GET_DOCTOR_APPOINTMENT_OVERVIEW,
  GET_DOCTOR_APPOINTMENT_OVERVIEW_SUCCESS,
  GET_DOCTOR_APPOINTMENT_OVERVIEW_ERROR,
  GET_DOCTOR_APPOINTMENT_OVERVIEW_RESET,
} = require('./constants')

const initialState = {
  appointmentsList: {
    data: null,
    loading: false,
    error: null,
  },
  appointmentDetails: {
    data: null,
    loading: false,
    error: null,
  },
  doctorAppointmentList: {
    data: null,
    loading: false,
    error: null,
  },
  doctorAppointmentOverview: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({
  [GET_USER_APPOINTMENTS_LIST]: draft => ({
    appointmentsList: {
      ...draft.appointmentsList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_USER_APPOINTMENTS_LIST_SUCCESS]: (draft, action) => ({
    appointmentsList: {
      ...draft.case,
      loading: false,
      data: action.payload,
    },
  }),
  [GET_USER_APPOINTMENTS_LIST_ERROR]: (draft, action) => ({
    appointmentsList: {
      ...draft.appointmentsList,
      loading: false,
      error: action.payload,
    },
  }),
  [GET_USER_APPOINTMENTS_LIST_RESET]: () => ({
    appointmentsList: { ...initialState.appointmentsList },
  }),

  [GET_USER_APPOINTMENT_DETAILS]: draft => ({
    appointmentDetails: {
      ...draft.appointmentDetails,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_USER_APPOINTMENT_DETAILS_SUCCESS]: (draft, action) => ({
    appointmentDetails: {
      ...draft.appointmentDetails,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_USER_APPOINTMENT_DETAILS_ERROR]: (draft, action) => ({
    appointmentDetails: {
      ...draft.appointmentDetails,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_USER_APPOINTMENT_DETAILS_RESET]: () => ({
    appointmentDetails: { ...initialState.appointmentDetails },
  }),

  [GET_DOCTOR_APPOINTMENT_LIST]: draft => ({
    doctorAppointmentList: {
      ...draft.doctorAppointmentList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_DOCTOR_APPOINTMENT_LIST_SUCCESS]: (draft, action) => ({
    doctorAppointmentList: {
      ...draft.doctorAppointmentList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_DOCTOR_APPOINTMENT_LIST_ERROR]: (draft, action) => ({
    doctorAppointmentList: {
      ...draft.doctorAppointmentList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_DOCTOR_APPOINTMENT_LIST_RESET]: () => ({
    doctorAppointmentList: { ...initialState.doctorAppointmentList },
  }),

  [GET_DOCTOR_APPOINTMENT_OVERVIEW]: draft => ({
    doctorAppointmentOverview: {
      ...draft.doctorAppointmentOverview,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_DOCTOR_APPOINTMENT_OVERVIEW_SUCCESS]: (draft, action) => ({
    doctorAppointmentOverview: {
      ...draft.doctorAppointmentOverview,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_DOCTOR_APPOINTMENT_OVERVIEW_ERROR]: (draft, action) => ({
    doctorAppointmentOverview: {
      ...draft.doctorAppointmentOverview,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_DOCTOR_APPOINTMENT_OVERVIEW_RESET]: () => ({
    doctorAppointmentOverview: { ...initialState.doctorAppointmentOverview },
  }),

}, initialState)
